import { type FC, type ReactNode, useCallback } from "react";
import { type FlagAction, FlagWithActions, type QueuedFlag } from "../patterns/flag";

const NO_ACTIONS: FlagAction[] = [];

type FlagsDisplayProps = {
	flags: QueuedFlag[];
	hideFlag: (id: string) => void;
	children: ReactNode;
};

type FlagItemProps = {
	flag: QueuedFlag;
	hideFlag: (id: string) => void;
};

const FlagItem: FC<FlagItemProps> = ({ flag, hideFlag }) => {
	const { id, heading, message, tone, actions, autoDismiss, onDismiss } = flag;

	const onClose = useCallback(() => {
		hideFlag(id);
		onDismiss?.();
	}, [hideFlag, id, onDismiss]);

	return (
		<FlagWithActions
			tone={tone}
			heading={heading}
			message={message}
			actions={actions ?? NO_ACTIONS}
			autoDismiss={autoDismiss}
			onClose={onClose}
		/>
	);
};

export const FlagsDisplay: FC<FlagsDisplayProps> = ({ flags, hideFlag, children }) => {
	return (
		<div data-testid="flags-display" className="flex relative">
			<div className="flex flex-col gap-2 absolute bottom-4 left-4 z-50">
				{flags.map((flag) => (
					<FlagItem key={flag.id} flag={flag} hideFlag={hideFlag} />
				))}
			</div>
			{children}
		</div>
	);
};
